import React from 'react';
import styled from 'styled-components';
import { BuildingHouse } from '@styled-icons/boxicons-regular';
import { Mobile } from '@styled-icons/boxicons-regular';
import { MapPin } from '@styled-icons/boxicons-regular';
import { Envelope } from '@styled-icons/boxicons-regular';
import { Building } from '@styled-icons/boxicons-regular';

const StyledInput = styled.input`
  background-color: transparent;
  border: none;
  background-image: none;
  box-shadow: none;
  grid-area: input;
  width: 100%;
  height: 100%;
  font-size: 1.1rem;
  font-weight: 600;
  &:focus {
    outline: none;
    box-shadow: none;
  }
  padding-right: 0.5rem;
`;

const Container = styled.div`
  height: 2.2rem;
  width: 100%;
  display: grid;
  grid-template-columns: auto auto 1fr;
  grid-template-areas: 'icon bar input';
  grid-column-gap: 0.2rem;
  justify-content: center;
  align-items: center;
  border: 2px solid gray;
  border-radius: 15px;
  margin-top: 0.5rem;
  margin-bottom: 1.5rem;
`;

const VerticalDivider = styled.div`
  grid-area: bar;
  height: 75%;
  padding-left: 0.2rem;
  padding-right: 0.2rem;
  border-left: 3px solid ${(p) => p.theme.primary};
`;

const IconContainer = styled.div`
  grid-area: icon;
  height: 100%;
  width: 100%;
  padding: 0.5rem;
  display: flex;
`;

const StyledBuildingHouse = styled(BuildingHouse)`
  height: 100%;
`;
const StyledPhone = styled(Mobile)`
  height: 100%;
`;
const StyledLocation = styled(MapPin)`
  height: 100%;
`;
const StyledBuilding = styled(Building)`
  height: 100%;
`;
const StyledEmail = styled(Envelope)`
  height: 100%;
`;

const iconSelector = (icon) => {
  switch (icon) {
    case 'address':
      return <StyledBuildingHouse />;
    case 'zipcode':
      return <StyledLocation />;
    case 'flat':
      return <StyledBuilding />;
    case 'telephone':
      return <StyledPhone />;
    case 'email':
      return <StyledEmail />;
    default:
      return null;
  }
};

function InputField({ icon, ...rest }) {
  return (
    <Container>
      <IconContainer>{iconSelector(icon)}</IconContainer>
      <VerticalDivider />
      <StyledInput {...rest} />
    </Container>
  );
}

export default InputField;
